import type { AppRouteObject } from "../routes";
import { TenantLogoRoute } from "./routes/TenantLogo";

const routes: AppRouteObject[] = [
    TenantLogoRoute,

];

export default routes;
